//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSelectionCard from "@/components/Generics/AQSelectionCard/AQSelectionCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";

export default {
    components: {
        AQButton,
        AQSelectionCard,
        AQModal,
        AQCard,
        AQMenu,
        AQChip,
        addNewMessage: () => import(/* webpackChunkName: "addNewMessage" */ "@/components/Diagrams/config/subcomponents/external-task-add-new-message.vue")
    },
    props: {
        uuid: {
            required: true,
            type: String
        },
        elementIndex: {
            type: Number,
            default: 0
        },
        readonly: {
            type: Boolean
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            modalOpened: false,
            smsSubject: null,
            showVariables: false,
            showAddMessage: false,
            messageType: false,
            messagesOptions: "",
            currentMessageIndex: null,
            msgActions: [{
                label: this.$t("diagrams.components.messagingOptions.actionDelete")
            }],
            popoverModel: []
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData", "getExternalTaskRegularMessages", "getExternalTaskDynamicMessages"])

    },
    watch: {
        getExternalTaskRegularMessages: {
            handler() {
                this.setMessagesType();
            },
            immediate: true
        },
        getExternalTaskDynamicMessages: {
            handler() {
                this.setMessagesType();
            },
            immediate: true
        }
    },
    mounted() {
        this.updateStore();
    },
    methods: {
        actionsDlg() {
            this.modalOpened = false;
        },
        openModal() {
            this.updateStore();
            this.modalOpened = true;
        },
        onFieldClicked(data) {
            this.computedValue += ` ${data.field.variable}`;
        },
        addEditMessageType(type, index) {
            this.showAddMessage = true;
            this.messageType = type === "dynamicMsg";
            this.currentMessageIndex = index;
        },
        deleteMessage(type) {
            this.popoverModel = [];
            const deleteMessage = {
                delete: true,
                externalMessageType: type === "dynamicMsg" ? "externalTaskDynamicMessages" : "externalTaskRegularMessages"
            };
            this.$store.commit("diagrams/setExternalTaskMessages", deleteMessage);

            this.$store.commit("diagrams/setConfigData", {
                uuid: this.uuid,
                value: {
                    regularMessages: this.getExternalTaskRegularMessages,
                    dynamicMessages: this.getExternalTaskDynamicMessages
                },
                property: "messagingOptions"
            });
        },
        setMessagesType() {
            this.messagesOptions = "";
            if (this.getExternalTaskRegularMessages.length && this.getExternalTaskDynamicMessages.length) {
                this.messagesOptions = (`${this.$t("diagrams.components.messagingOptions.regularMsgType")}, 
                ${this.$t("diagrams.components.messagingOptions.dynamicMsgType")}`);
            } else if (this.getExternalTaskRegularMessages.length) {
                this.messagesOptions = this.$t("diagrams.components.messagingOptions.regularMsgType");
            } else if (this.getExternalTaskDynamicMessages.length) {
                this.messagesOptions = this.$t("diagrams.components.messagingOptions.dynamicMsgType");
            }
        },
        updateStore() {
            if (this.value) {
                this.$store.commit("diagrams/setExternalTaskMessages", { data: this.value.regularMessages,
                    externalMessageType: "externalTaskRegularMessages" });
            } else {
                this.$store.commit("diagrams/setExternalTaskMessages", { data: [], externalMessageType: "externalTaskRegularMessages" });
            }

            if (this.value) {
                this.$store.commit("diagrams/setExternalTaskMessages", { data: this.value.dynamicMessages,
                    externalMessageType: "externalTaskDynamicMessages" });
            } else {
                this.$store.commit("diagrams/setExternalTaskMessages", { data: [], externalMessageType: "externalTaskDynamicMessages" });
            }
        },
        getChipType(data) {
            const valueStart = data.slice(0, 2);
            return valueStart === "m_" ? "m_datamodel" : "s_datamodel";
        }
    }

};
